import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { AppEnvironment } from "@/store/app/state";
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const messageReactionId = useComputedValue<string | null>(
  GetterTypes.GET_MESSAGE_REACTION_ID,
);
const environment = useComputedValue<AppEnvironment>(
  GetterTypes.GET_APP_ENVIRONMENT,
);
const isReacting = computed(() => !!messageReactionId.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["main-layout", {
      webview: _unref(environment).isMobileApp,
      isReacting: isReacting.value,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})